import React from 'react';
import FormattedAddress from 'components/FormattedAddress';
import Moment from 'moment';
import TextTruncate from 'react-text-truncate';

const ReportListItem = ({ data, toReport, noDescription, modules, shortenText, shortenTo }) => {
	const { images, reportId, address, insertDate, description, type } = data;

	if (!shortenTo) {
		shortenTo = 2;
	}

	return (
		<li className="media media-list post-list">
			<div className="size-80 post-image mr-3">
				<div className="grid-thumb-equal rounded">
					<div className="grid-thumb-cover">
						<img className="img-fluid rounded" src={images[0] ? images[0].thumbnail : 'assets/images/noimage.svg'} alt="user-image" />
					</div>
				</div>
			</div>
			<div className="media-body">
				<h4 className="mt-0 mb-1">{`${type.description}`}</h4>
				{
					//				<h4 className="mt-0 mb-1">{`Meldung ${reportId}`}</h4>
					//			<p className="meta-date mb-1">{Moment(insertDate).format('DD.MM.YYYY hh:mm')}</p>
				}
				{!noDescription && (
					<p className="text-muted" style={{ marginBottom: 0 }}>
						{shortenText ? (
							<TextTruncate key={new Date().getTime()} line={shortenTo} element="span" truncateText="…" text={description} />
						) : (
							description
						)}
					</p>
				)}
				{modules && modules.reportDetails && (
					<span className="text-blue pointer" onClick={() => toReport(reportId)}>
						Mehr...
					</span>
				)}
			</div>
		</li>
	);
};

export default ReportListItem;



// WEBPACK FOOTER //
// ./components/ReportListItem/index.js